<template>
    <div>
        <van-nav-bar class="header" :title="activityTheme" left-arrow @click-left="onClickLeft" fixed/>
        <van-list
                v-model="loading"
                class="list-box"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
        >
            <div class="item-box" v-for="item in list" :key="item.uuid" @click="toDetail(item.uuid)">
                <img :src="avatarUrl + item.images" class="" alt="">
                <div class="item-content">
                    <p>{{item.theme}}</p>
                    <span>{{item.typeIdname}}</span>
                </div>
                <span class="createTime">{{item.time}}</span>
            </div>
        </van-list>



    </div>
</template>

<script>
    import {CellGroup,Button,Field,NavBar,Cell, List } from 'vant';
    import {API_URL} from "../../common/config";
    import moment from "moment";
    import {formatDictionary} from "../../utils/dictionary";
    // import {getKey} from "../utils/url";
    import activityListService from "../../service/activityListService";

    export default {
        data: function () {
            return {
                activityTheme:'市场活动',
                list: [],
                typeList: [],
                loading: false,
                finished: false,
                pageIndex:0,
                pageSize:20,
                expressions:'[{"field":"数量","expression":"count(1)"}]',
                dictionaryNames:'typeId.dict_activity_type'

            }
        },
        components: {
            [Cell.name]: Cell,
            [List.name]: List,
            [Field.name]: Field,
            [Button.name]: Button,
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup
        },
        computed: {
            avatarUrl() {
                return API_URL + "/oa/common/attachment/showImage?id=";
            },
        },
        mounted: async function() {
            let resp = await activityListService.getActivityTypeId();
            if (resp.data.Status === "1") {
                this.typeList = resp.data.Data;
            }
        },
        methods:{
            async onLoad() {
                this.pageIndex++;
                let resp = await activityListService.getActivityList(this.dictionaryNames,this.expressions,this.pageSize,this.pageIndex);
                if (resp.data.Status === "1") {
                    resp.data.Data.data.forEach(item => {
                        if(item.images) {
                            item.images = item.images.split(',')[0];
                        }
                        item.time = moment(item.time).format('YYYY-MM-DD');
                        //item.activityType = this.typeList.find(typeItem=>typeItem.uuid==item.typeId).name;
                    });
                    formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                    this.list = [...this.list, ...resp.data.Data.data];
                    // 加载状态结束
                    this.loading = false;

                    // 数据全部加载完成
                    this.finished = resp.data.Data.total <= this.list.length;
                }

            },
            onClickLeft() {
                window.location.href="/colseWebView";
            },
            toDetail(id) {
                this.$router.push({path:"ActivityDetails",query:{id:id}})
            }
        }
    };

</script>
<style scoped>
    .header {
        height:120px;
    }
    .van-nav-bar__left {
        height:100%;
    }
    .van-nav-bar__left i {
        font-size:1.5rem;
    }
    .list-box {
        margin-top: 120px;
    }
    .item-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:30px 15px;
        border-bottom:1px solid #cccccc;
    }
    .item-box img {
        width:3rem;
        height:3rem;
    }
    .item-content {
        margin:0 30px;
        flex:1;
    }
    .item-content p {
        margin:0;
        font-size:1rem;
        color:#333;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .item-content span {
        font-size:0.8rem;
        color:#333;
    }
    .createTime {
        font-size:0.8rem;
        color: #999999;
    }
</style>
